import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Supplier1688Item } from '../supplier-1688';

// A product's 1688 links, one per part of a set, on one line: the Reordering
// grid pins its rows to one height. Shared by the grids and the Orders popup.
@Component({
    selector: 'app-supplier-1688-links',
    templateUrl: './supplier-1688-links.component.html',
    styleUrls: ['./supplier-1688-links.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Supplier1688LinksComponent {
    @Input({ required: true }) supplier!: Supplier1688Item;
}
